import { render, staticRenderFns } from "./VisualizationUserAccess.vue?vue&type=template&id=615c2f08&lang=pug"
import script from "./VisualizationUserAccess.vue?vue&type=script&lang=js"
export * from "./VisualizationUserAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615c2f08')) {
      api.createRecord('615c2f08', component.options)
    } else {
      api.reload('615c2f08', component.options)
    }
    module.hot.accept("./VisualizationUserAccess.vue?vue&type=template&id=615c2f08&lang=pug", function () {
      api.rerender('615c2f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tableau/VisualizationUserAccess.vue"
export default component.exports